module.exports = __webpack_public_path__ + "static/media/af.b040d017.svg";